import state from './healthcheckdef.state'
import mutations from './healthcheckdef.mutations'
import actions from './healthcheckdef.actions'

export default {
  state,
  mutations,
  actions
}
